// extracted by mini-css-extract-plugin
export default {"alert":"CustomAlert_alert__ES0qN","textContainer":"CustomAlert_textContainer__jx8Zd","title":"CustomAlert_title__c4VCl","text":"CustomAlert_text__9zN32"};